import React, { useState, useMemo } from 'react';
import CSPage from '../../components/CSPage';
import CSPageHeader from '../../components/CSPageHeader';
import LegacyHolisticProjectReportsTab from '../holistic-quarterly-reports/LegacyHolisticProjectReportsTab';
import ScheduledHolisticProjectReportsTab from './ScheduledHolisticProjectReportsTab';
import { Typography, Tabs } from 'antd';
import { FormOutlined } from '@ant-design/icons';
import useQueryParams from '../../shared/use-query-params';

const { Title } = Typography;

function ListHolisticProjectReportsPage() {
  const query = useQueryParams();
  const [activeTab, setActiveTab] = useState(() => query.tab || 'scheduled');
  const [sharedFilters, setSharedFilters] = useState({
    peopleGroupId: undefined,
    regionCode: undefined,
    projectCoordId: undefined,
    projectNumberSearch: '',
    frequency: 'ALL',
    search: undefined,
    status: undefined,
  });

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <>
      <CSPage
        containerStyle={{ maxWidth: 'unset' }}
        title="Holistic Project Reports"
      >
        <CSPageHeader
          titleComponent={
            <Title>
              <FormOutlined style={{ marginRight: 16 }} />
              {'Holistic Project Reports'}
            </Title>
          }
        />
        <Tabs activeKey={activeTab} onChange={handleTabChange}>
          <Tabs.TabPane tab="Scheduled Reports" key="scheduled">
            <ScheduledHolisticProjectReportsTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Legacy Quarterly Reports" key="legacy">
            <LegacyHolisticProjectReportsTab
              sharedFilters={sharedFilters}
              onSharedFiltersChange={setSharedFilters}
              initialReportCategory={query.reportCategoryKey || 'pending'}
            />
          </Tabs.TabPane>
        </Tabs>
      </CSPage>
      <style jsx>{``}</style>
    </>
  );
}

export default ListHolisticProjectReportsPage;
